import { z } from 'zod';

const PaymentApprovalAction = z.literal('PAYMENT_SIGNING_STATUS_UPDATE');

type PaymentApprovalAction = z.infer<typeof PaymentApprovalAction>;

export enum PaymentStatusEnum {
    CREATED = 'CREATED',
    SENDING_TO_PROVIDER_IN_PROGRESS = 'SENDING_TO_PROVIDER_IN_PROGRESS',
    SENT_TO_PROVIDER = 'SENT_TO_PROVIDER',
    DECLINED = 'DECLINED',
    CANCELED = 'CANCELED',
    UNKNOWN = 'UNKNOWN',
}

export enum PaymentApprovalErrorEnum {
    PAYMENT_NOT_FOUND = 'PAYMENT_NOT_FOUND',
    INVALID_DYNAMIC_LINK = 'INVALID_DYNAMIC_LINK',
    UNKNOWN_CARD = 'UNKNOWN_CARD',
    UNKNOWN_ACCOUNT = 'UNKNOWN_ACCOUNT',
    INACTIVE_ACCOUNT = 'INACTIVE_ACCOUNT',
    INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
    INVALID_PAYMENT_STATUS = 'INVALID_PAYMENT_STATUS',
    INVALID_CURRENCY = 'INVALID_CURRENCY',
    INVALID_AMOUNT = 'INVALID_AMOUNT',
    EXCEEDED_LIMIT = 'EXCEEDED_LIMIT',
    DELINQUENT_ACCOUNT = 'DELINQUENT_ACCOUNT',
    NO_AGREEMENT = 'NO_AGREEMENT',
    INTERNAL_ERROR = 'INTERNAL_ERROR',
}

const PaymentApprovalErrorSchema = z.enum(Object.values(PaymentApprovalErrorEnum) as [`${PaymentApprovalErrorEnum}`]);
export type PaymentApprovalError = z.infer<typeof PaymentApprovalErrorSchema>;

const PaymentStatusSchema = z.enum(Object.values(PaymentStatusEnum) as [`${PaymentStatusEnum}`]);

export const PaymentApprovalMessageSchema = z.object({
    action: PaymentApprovalAction,
    approvalError: PaymentApprovalErrorSchema.nullish(),
    status: PaymentStatusSchema,
});

const MobilePaymentApprovalAction = z.literal('SIGNING_STATUS_UPDATE_PAYMENT');

const MobilePaymentPayloadSchema = z
    .enum(Object.values(PaymentStatusEnum) as [`${PaymentStatusEnum}`])
    .or(z.literal('REJECTED'))
    .or(z.literal('COMPLETED'));

export type MobilePaymentStatus = z.infer<typeof MobilePaymentPayloadSchema>;

export const MobilePaymentApprovalMessageSchema = z.object({
    action: MobilePaymentApprovalAction,
    payload: MobilePaymentPayloadSchema,
});

export const DeeplinkPayloadSchema = z
    .string()
    .nonempty()
    .transform((val, ctx) => {
        const match = val.match(/signingresult\/(\S+)/);

        if (match) {
            return match[1];
        }

        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'invalid payload',
            path: ['payload'],
        });

        return undefined;
    })
    .pipe(MobilePaymentPayloadSchema);

export const DeeplinkMessageSchema = z.object({
    action: z.literal('DEEPLINK_RESULT'),
    payload: DeeplinkPayloadSchema,
});
